import { AlertIcon } from "../../icons/AlertIcon";

type NoDataProps = {
  title: string;
  children: React.ReactNode;
};

export const NoData = ({ title, children }: NoDataProps) => {
  return (
    <div className="items-center flex flex-col mt-[80px]">
      <AlertIcon />
      <span className="mt-2 font-semibold text-base">{title}</span>
      <div className="mt-1">{children}</div>
    </div>
  );
};
